import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    PositionType,
} from 'app/enums/label.enums'
import {
    LongTermLeaseInvoicePositionType,
} from 'app/requests/LongTermLeaseInvoice/LongTermLeaseInvoice.types'

const getFields = (
    {
        positionCodeAllowedValues,
        getAllowedValues,
    }: {
        positionCodeAllowedValues: Record<string, any>,
        getAllowedValues: (enumType: Record<string, string>) => Record<string, string>
    },
): DTOCardFormField<keyof LongTermLeaseInvoicePositionType>[] => {
    return [{
        id: 'positions',
        title: 'POSITIONS',
        className: 'positions',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'positionType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(PositionType),
                        useDropdown: true,
                        required: true,
                        labelKey: 'POSITION_TYPE',
                    },
                    {
                        name: 'positionCode',
                        componentName: 'EnumSelector',
                        allowedValues: positionCodeAllowedValues,
                        useDropdown: true,
                        required: true,
                        labelKey: 'POSITION',
                        showOutOfRangeOption: true,
                    },
                ],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'quantity',
                    className: 'quantity',
                    componentName: 'IntegerInput',
                    min: 0,
                    required: true,
                    labelKey: 'QUANTITY',
                }],
            },
            {
                id: 'column3',
                fields: [{
                    name: 'unitPrice',
                    className: 'unitPrice',
                    componentName: 'IntegerInput',
                    min: 0,
                    required: true,
                    labelKey: 'UNIT_PRICE',
                }],
            },
            {
                id: 'column4',
                fields: [{
                    name: 'positionDescription',
                    className: 'positionDescription',
                    componentName: 'LongText',
                    rows: 5,
                    labelKey: 'DESCRIPTION',
                }],
            },
        ],
    }]
}

export default getFields
